export default __webpack_public_path__ + "static/media/regulatory--no-vehicles-carrying-explosives--g1.0565ddd2.png";